import React from 'react';

interface AccumulatorParamsProps {
  growthRate: number;
  takeProfitEnabled: boolean;
  takeProfitAmount: number;
  onGrowthRateChange: (rate: number) => void;
  onTakeProfitEnabledChange: (enabled: boolean) => void;
  onTakeProfitAmountChange: (amount: number) => void;
}

const AccumulatorParams: React.FC<AccumulatorParamsProps> = ({
  growthRate,
  takeProfitEnabled,
  takeProfitAmount,
  onGrowthRateChange,
  onTakeProfitEnabledChange,
  onTakeProfitAmountChange
}) => {
  return (
    <>
      <div className="parameter-group">
        <label>Growth Rate</label>
        <div className="growth-rate-selector">
          {[1,2,3,4,5].map(rate => (
            <button 
              key={rate}
              className={`growth-btn ${growthRate === rate ? 'active' : ''}`}
              onClick={() => onGrowthRateChange(rate)}
            >
              {rate}%
            </button>
          ))}
        </div>
      </div>

      <div className="parameter-group">
        <label>Take Profit (Optional)</label>
        <div className="take-profit-group">
          <label className="checkbox-container">
            <input 
              type="checkbox" 
              className="take-profit-toggle"
              checked={takeProfitEnabled}
              onChange={(e) => onTakeProfitEnabledChange(e.target.checked)}
            />
            <span className="checkbox-custom"></span>
            <span className="checkbox-label">Set take profit</span>
          </label>
          <input 
            type="number" 
            className="input-field take-profit-input" 
            value={takeProfitAmount}
            onChange={(e) => onTakeProfitAmountChange(Number(e.target.value))}
            disabled={!takeProfitEnabled}
          />
        </div>
      </div>

      <div className="parameter-group">
        <label>Barrier Information</label>
        <div className="barrier-display">
          <div className="barrier-row">
            <span>Upper Barrier:</span>
            <span className="barrier-value">1.08653</span>
          </div>
          <div className="barrier-row">
            <span>Lower Barrier:</span>
            <span className="barrier-value">1.08247</span>
          </div>
          <div className="barrier-warning">
            <span>⚠️ Trade closes if price touches barriers</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccumulatorParams;
export { AccumulatorParams };
